'use client';

import { TrustpilotBrandmarkBlack, TrustpilotBrandmarkWhite, TrustpilotRatings5Star } from '@byway/icons';
import { useTranslations } from 'next-intl';
import styles from './HeaderLogos.module.css';

export const HeaderLogos = () => <TrustBoxStatic variant="white" />;

type TrustBoxStaticProps = {
  variant?: 'black' | 'white';
};

export const TrustBoxStatic = ({ variant = 'black' }: TrustBoxStaticProps) => {
  const t = useTranslations('aria');
  return (
    <div>
      <a
        href="https://uk.trustpilot.com/review/byway.travel"
        className={styles.trustpilot}
        rel="noreferrer noopener"
        target="_blank"
        aria-label={t('trustpilot_reviews')}
      >
        {variant === 'black' ? (
          <TrustpilotBrandmarkBlack ariaLabel="Trustpilot" size="scale" />
        ) : (
          <TrustpilotBrandmarkWhite ariaLabel="Trustpilot" size="scale" />
        )}
        <div className={styles.spacer} />
        <TrustpilotRatings5Star ariaLabel={t('five_star')} size="scale" />
      </a>
    </div>
  );
};
